import React from 'react';
import EmbedViewDisabledHandler from 'embed/handlers/EmbedViewDisabledHandler';
import AuthoritySwitch, {AUTHORITIES} from 'components/AuthoritySwitch';
import {FormattedMessage} from 'react-intl';
import {FeatureEnabled, FEATURE_SWITCHES} from 'components/FeatureSwitch';
import {RpcEndpointProvider} from 'components/RpcEndpoint';

const disabled = (
  <EmbedViewDisabledHandler
    title={
      <FormattedMessage
        id="EmbedAppHandler__DisabledTitle"
        description="Title for when attempting to access Domo Everywhere when disabled"
        defaultMessage="Domo Everywhere is not enabled"
      />
    }
    instructions={
      <FormattedMessage
        id="EmbedAppHandler__DisabledInstructions"
        description="Instructions for what to do to enable Domo Everywhere"
        defaultMessage="Please contact your Major Domo"
      />
    }
  />
);

const locked = (
  <EmbedViewDisabledHandler
    title={
      <FormattedMessage
        id="EmbedAppHandler__LockedTitle"
        description="Title for when attempting to access Domo Everywhere without access"
        defaultMessage="Your account does not permit viewing embedded content."
      />
    }
    instructions={
      <FormattedMessage
        id="EmbedAppHandler__LockedInstructions"
        description="Instructions for what to do to get access to Domo Everywhere"
        defaultMessage="Please contact your administrator"
      />
    }
  />
);

const EmbedAppHandler = ({children}) => (
  <React.Fragment>
    <FeatureEnabled
      feature={FEATURE_SWITCHES.EMBED_CARD_VIEW}
      disabledContent={disabled}
    >
      <AuthoritySwitch
        authority={AUTHORITIES.CONTENT_INTERACTIVE}
        lockedView={locked}
      >
        <RpcEndpointProvider>{children}</RpcEndpointProvider>
      </AuthoritySwitch>
    </FeatureEnabled>
  </React.Fragment>
);

export default EmbedAppHandler;
